const tabsItems = [...document.querySelectorAll('.j-tabs__item[data-tab-title]')];
const tabsTitle = document.querySelector('.j-tabs-title');

tabsItems.forEach((item) => {
    if (item.classList.contains('is-active')) {
        tabsTitle.innerText = item.dataset.tabTitle;
    }

    item.addEventListener('click', (event) => {
        tabsTitle.innerText = event.target.dataset.tabTitle;
    });
});
